import { Component, Input } from "@angular/core";

@Component({
    selector: "ng-wait",
    template: `
        <div class="ng-wait">
            <div *ngIf="overlay" class="ng-wait-overlay"></div>
            <div class="ng-wait-content">
                <p-progressSpinner></p-progressSpinner>
                <div class="ng-wait-text">{{loadingText}}</div>
            </div>
        </div>
    `,
    styles: ["./ng-wait.component.css"]
})
export class NgWaitComponent {
    @Input() loadingText = "Loading...";
    @Input() overlay = true;
}
